import React from 'react';
import { IntroHeadlineProps } from "types/intro-headline-props";
import IntroHeadline from 'components/partials/parts/intro-headline';
import CategoryIconCard, { CategoryIconCardProps } from 'components/partials/parts/category-icon-card';

export type CategoryIconCardsProps = {
    introHeadlineProps: IntroHeadlineProps;
    cards: CategoryIconCardProps[];
};

const CategoryIconCards: React.FC<CategoryIconCardsProps> = ({ cards, introHeadlineProps }) => (
    <div className="pattern pattern--pad pattern--has-bgcolor bg-brand-red pattern--category-icon-cards">
        <div className="container">
            <IntroHeadline {...introHeadlineProps} />
            <div className="grid-container">
                {cards.map((card, index) => (
                    <CategoryIconCard key={index} {...card} />
                ))}
            </div>
        </div>
    </div>
);

export default CategoryIconCards;